<template>
  <div>
    <b-card no-body>
      <b-col>
        <b-form-group label-align="right" :label="$t('Start date')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="datetime-local" v-model="vodService.start_date" :disabled="activeService"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('End date')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="activeService">
          <b-form-input type="datetime-local" v-model="endDate" disabled/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Charged')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="isEdit">
          <b-input-group>
            <b-form-input type="text" disabled v-model="serviceStats.charged_in_curr_period"/>
            <b-input-group-append>
              <b-button variant="info" size="sm" :disabled="!isEdit">{{ $t('Details') }}</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Cost %')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="number" v-model="vodService.cost_coef" :disabled="activeService"/>
        </b-form-group>
        <div v-if="fullVODData.vod_service_data">
          <b-form-group label-align="right" :label="$t('IPTV access card')" :disabled="isEdit === true" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="fullVODData.vod_service_data.type == 0">
            <b-form-select :options="accessCards" v-model="vodService.comment"/>
          </b-form-group>
        </div>
      </b-col>
    </b-card>
    <b-row>
      <b-col>
        <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="saveVodService" v-if="!activeService">Ok</b-button>
      </b-col>
      <b-col sm="1.5">
        <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click="hideSelectService">{{ $t('Cancel') }}</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import axiosInstance from '@/utils/api.js'
import moment from 'moment'

export default {
  props: {
    tariffLinkId: 0,
    currentUser: null,
    currentService: null,
    selectedAccount: null,
    isEdit: null
  },
  data () {
    return {
      activeService: false,
      serviceStats: null,
      endDate: 0,
      vodService: {
        'user_id': 0,
        'account_id': 0,
        'service_id': 0,
        'tariff_link_id': 0,
        'start_date': moment().format('YYYY-MM-DDThh:mm'),
        'cost_coef': 100,
        'comment': ''
      },
      fullVODData: {}
    }
  },
  methods: {
    saveVodService () {
      this.vodService.tariff_link_id = this.tariffLinkId ? this.tariffLinkId : 0
      this.vodService.start_date = Number(Date.parse(this.vodService.start_date)) / 1000
      this.vodService.cost_coef = this.vodService.cost_coef / 100
      this.vodService.comment = String(this.vodService.comment)
      if (this.isEdit) {
        let editVodService = {
          'slink_id': 0,
          'start_date': 0,
          'cost_coef': 0
        }
        editVodService.slink_id = this.currentService.service_link_id
        editVodService.cost_coef = this.vodService.cost_coef
        editVodService.start_date = this.vodService.start_date
        axiosInstance.put(this.$store.getters.API_USERS_SERVICELINKS_VOD, editVodService).then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            this.$root.$emit('makeToasts')
            this.$emit('hideSelectService')
            this.$emit('refreshTable')
          }
        })
      } else {
        axiosInstance.post(this.$store.getters.API_USERS_SERVICELINKS_VOD, this.vodService).then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            this.$root.$emit('makeToasts')
            this.$emit('hideSelectService')
            this.$emit('refreshTable')
          }
        })
      }
    },
    async load () {
      this.fullVODData = await axiosInstance.get(this.$store.getters.API_TARIFFING_SERVICES_VOD + '?service_id=' + this.currentService.service_id).then(response => { return response.data })

      this.vodService.account_id = this.selectedAccount
      this.vodService.user_id = this.currentUser.user_id
      this.vodService.service_id = this.currentService.service_id
      if (this.isEdit) {
        this.serviceStats = await axiosInstance.get(this.$store.getters.API_USERS_SERVICELINKS_PERIODIC_SLINK_STATS + '?slink_id=' + this.currentService.service_link_id).then(response => { return response.data })
        this.vodService.cost_coef = this.serviceStats.cost_coef * 100
        let newDate = Number(Date.parse(new Date())) / 1000
        if (newDate > this.serviceStats.start_date) {
          this.activeService = true
          this.endDate = moment(Number(this.serviceStats.expire_date) * 1000).format('YYYY-MM-DDThh:mm')
        }
        this.vodService.start_date = moment(Number(this.serviceStats.start_date) * 1000).format('YYYY-MM-DDThh:mm')
      }
    },
    hideSelectService () {
      this.$emit('hideSelectService')
    },
    refreshTable () {
      this.$emit('refreshTable')
    }
  },

  computed: {
    accessCards () {
      let tmp = this.$store.getters['Users/ACCESS_CARDS']
      for (let el of tmp) {
        el.text = el.username + '(' + el.card_number + ')'
        el.value = el.card_number
      }
      return tmp
    }
  },
  mounted () {
    this.load()
    this.$store.dispatch('Users/GET_ACCESS_CARDS', this.currentUser.user_id)
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/serviceLinks/formVOD.vue